(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belly-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.bellySizeGuideV5) return;
  window.bellySizeGuideV5 = true;
  function prepare(root) {
    root.querySelectorAll('[data-belly-size-guide]').forEach(function (trigger) {
      trigger.removeAttribute('aria-haspopup');
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('.belly-size-dialog').forEach(function (dialog) {
      if (dialog.dataset.bellyReady) return;
      dialog.dataset.bellyReady = 'true';
      dialog.addEventListener('close', function () {
        if (dialog.dataset.bellyInline === 'true' && dialog.bellyOpener) dialog.bellyOpener.setAttribute('aria-expanded', 'false');
        if (dialog.bellyOpener && dialog.bellyOpener.isConnected) dialog.bellyOpener.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  function inlineGuide(trigger, source) {
    var holder = trigger.parentElement.querySelector('.belly-size-inline');
    if (holder) return holder.querySelector('.belly-size-dialog');
    if (!source) return null;
    holder = document.createElement('div');
    holder.className = 'belly-guide belly-size-inline';
    holder.setAttribute('data-belly-guide', '');
    var dialog = source.cloneNode(true);
    dialog.removeAttribute('open');
    dialog.removeAttribute('data-belly-ready');
    dialog.dataset.bellyInline = 'true';
    dialog.setAttribute('role', 'region');
    var ids = new Map();
    [dialog].concat(Array.from(dialog.querySelectorAll('[id]'))).forEach(function (element) {
      if (!element.id) return;
      var original = element.id;
      element.id = original + '-inline';
      ids.set(original, element.id);
    });
    [dialog].concat(Array.from(dialog.querySelectorAll('*'))).forEach(function (element) {
      ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (value) element.setAttribute(attribute, value.split(' ').map(function (id) { return ids.get(id) || id; }).join(' '));
      });
    });
    holder.appendChild(dialog);
    trigger.after(holder);
    trigger.removeAttribute('aria-haspopup');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', 'false');
    prepare(holder);
    return dialog;
  }
  function syncDesignLinks() {
    var source = document.querySelector('[data-belly-design-variants]');
    if (!source) return;
    var variants;
    try { variants = JSON.parse(source.textContent); } catch (error) { return; }
    var selectedId = new URL(window.location.href).searchParams.get('variant');
    var designInput = document.querySelector('product-details input[type="radio"][name^="option-1-"]:checked');
    var sizeInput = document.querySelector('product-details input[type="radio"][name^="option-2-"]:checked');
    var selected = designInput && sizeInput && variants.find(function (variant) { return variant.design === designInput.value && variant.size === sizeInput.value; });
    if (!selected) selected = variants.find(function (variant) { return String(variant.id) === selectedId; });
    if (!selected) return;
    document.querySelectorAll('[data-belly-design]').forEach(function (link) {
      var target = variants.find(function (variant) { return variant.design === link.dataset.bellyDesign && variant.size === selected.size; });
      if (!target) return;
      link.setAttribute('href', target.url);
      if (target.design === selected.design) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      var price = link.querySelector('small');
      if (price) price.textContent = target.available ? target.price + ' · ' + target.size : 'Scopri disponibilità';
    });
  }
  ['pointerdown', 'focusin'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.closest('[data-belly-design],.belly-purchase-designs,.belly-more-designs')) syncDesignLinks();
    });
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-belly-design]')) syncDesignLinks();
  }, true);
  document.addEventListener('change', function () { window.setTimeout(syncDesignLinks, 300); });
  document.addEventListener('popstate', syncDesignLinks);
  function refreshScale(dialog) {
    var width = Number(dialog.dataset.measureWidth);
    var length = Number(dialog.dataset.measureLength);
    var round = dialog.dataset.measureShape === 'round';
    var selector = dialog.querySelector('[data-belly-reference-height]');
    var reference = Number(selector.value) || 170;
    var rect = dialog.querySelector('[data-belly-scale-rect]');
    rect.toggleAttribute('hidden', round);
    rect.setAttribute('width', width);
    rect.setAttribute('height', length);
    rect.setAttribute('y', 225 - length);
    var circle = dialog.querySelector('[data-belly-scale-circle]');
    circle.toggleAttribute('hidden', !round);
    circle.setAttribute('cx', 35 + width / 2);
    circle.setAttribute('cy', 225 - width / 2);
    circle.setAttribute('r', width / 2);
    var widthLine = dialog.querySelector('[data-belly-scale-width]');
    widthLine.setAttribute('d', 'M35 236H' + (35 + width) + 'M35 232V240M' + (35 + width) + ' 232V240');
    var widthLabel = dialog.querySelector('[data-belly-width-label]');
    widthLabel.setAttribute('x', 35 + width / 2);
    widthLabel.textContent = (round ? 'Ø ' : '') + width + ' cm';
    var lengthLine = dialog.querySelector('[data-belly-scale-length]');
    lengthLine.toggleAttribute('hidden', round);
    lengthLine.setAttribute('d', 'M23 ' + (225 - length) + 'V225M19 ' + (225 - length) + 'H27M19 225H27');
    var lengthLabel = dialog.querySelector('[data-belly-length-label]');
    var labelY = 225 - length / 2;
    lengthLabel.toggleAttribute('hidden', round);
    lengthLabel.setAttribute('y', labelY);
    lengthLabel.setAttribute('transform', 'rotate(-90 13 ' + labelY + ')');
    lengthLabel.textContent = length + ' cm';
    var scale = reference / 170;
    dialog.querySelector('[data-belly-scale-person]').setAttribute('transform', 'translate(285 225) scale(' + scale + ') translate(-285 -225)');
    dialog.querySelector('[data-belly-reference-label]').textContent = 'Persona · ' + reference + ' cm';
    dialog.querySelector('[data-belly-scale-title]').textContent = dialog.dataset.measureTitle + ', a confronto con una persona alta ' + reference + ' centimetri. Scala costante.';
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-belly-reference-height]')) refreshScale(event.target.closest('dialog'));
  });
  document.addEventListener('click', function (event) {
    var purchaseGuide = event.target.closest('[data-belly-size-guide]');
    var opener = event.target.closest('[data-belly-size-open]');
    var purchasePanel = null;
    if (purchaseGuide) {
      var story = document.querySelector('.belly-guide--story');
      var linkedDialog = story && story.querySelector('.belly-size-dialog');
      purchasePanel = inlineGuide(purchaseGuide, linkedDialog);
      if (purchasePanel && purchasePanel.open) {
        event.preventDefault();
        event.stopImmediatePropagation();
        purchasePanel.close();
        return;
      }
      var selected = Array.from(document.querySelectorAll('#MainContent input[data-product-variant]:checked, #MainContent [data-dropdown-button] [data-selected-option]')).map(function (control) { return (control.value || control.textContent || '').trim(); }).find(function (value) { return /^[SML](?:\b|\s|\()/i.test(value); });
      var size = selected ? selected.charAt(0).toUpperCase() : 'Misura unica';
      opener = story && (story.querySelector('.belly-size-card[data-size="' + size + '"]') || story.querySelector('.belly-size-card'));
      if (opener) { event.preventDefault(); event.stopImmediatePropagation(); }
    }
    if (opener) {
      var section = opener.closest('[data-belly-guide]');
      if (!section) return;
      prepare(section);
      var dialog = purchasePanel || section.querySelector('.belly-size-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (!dialog.open) dialog.bellyOpener = purchaseGuide || opener;
      dialog.querySelector('h3').textContent = opener.dataset.size === 'Misura unica' ? 'Sport · diametro 110 cm' : 'Confronta la misura ' + opener.dataset.size;
      dialog.querySelector('[data-belly-dialog-measure]').textContent = opener.dataset.measure;
      var sizeContext = {
        S: 'S misura 1,20 × 1,50 metri: è la misura più piccola della linea.',
        M: 'M misura 1,40 × 1,80 metri: 20 cm più larga e 30 cm più lunga della S.',
        L: 'L misura 1,40 × 2,00 metri. È larga quanto la M, con 20 cm in più di lunghezza.',
        'Misura unica': 'Il diametro è 1,10 metri per Calcio, Tennis e Basket. Tieni conto anche dello spazio intorno alla seduta.'
      };
      dialog.querySelector('[data-belly-size-context]').textContent = sizeContext[opener.dataset.size] || '';
      dialog.dataset.measureWidth = opener.dataset.width;
      dialog.dataset.measureLength = opener.dataset.length;
      dialog.dataset.measureShape = opener.dataset.shape;
      dialog.dataset.measureTitle = (opener.dataset.size === 'Misura unica' ? 'Sport' : 'Misura ' + opener.dataset.size) + ': ' + opener.dataset.measure;
      dialog.querySelectorAll('.belly-size-tab').forEach(function (tab) { tab.setAttribute('aria-pressed', String(tab.dataset.size === opener.dataset.size)); });
      refreshScale(dialog);
      if (!dialog.open) {
        if (dialog.dataset.bellyInline === 'true') {
          dialog.show();
          if (dialog.bellyOpener) {
            dialog.bellyOpener.setAttribute('aria-expanded', 'true');
            dialog.bellyOpener.focus({ preventScroll: true });
          }
        } else dialog.showModal();
      }
      return;
    }
    var close = event.target.closest('[data-belly-dialog-close]');
    if (close) { close.closest('dialog').close(); return; }
    var returnLink = event.target.closest('[data-belly-return-to-options]');
    if (returnLink) {
      var openDialog = returnLink.closest('dialog');
      if (openDialog) { openDialog.bellyOpener = null; openDialog.close(); }
      var main = document.getElementById('MainContent') || document.querySelector('main');
      var form = main && main.querySelector('form[action*="/cart/add"]');
      if (form || main) {
        event.preventDefault();
        var target = form || main;
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        var firstControl = form && Array.from(form.querySelectorAll('select,button,input:not([type="hidden"]),[tabindex="0"]')).find(function (element) { return element.offsetParent !== null && !element.disabled; });
        if (firstControl) firstControl.focus({ preventScroll: true });
        else { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      }
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(document); });
  else prepare(document);
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belly-instagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let watchedBanner;
    let observer;
    const syncFilm = () => {
      const banner = document.querySelector('.shopify-section-group-header-group scrolling-banner .banner');
      if (!banner) return;
      const style = getComputedStyle(banner);
      const durationText = style.animationDuration.split(',')[0];
      const duration = parseFloat(durationText) / (durationText.trim().endsWith('ms') ? 1000 : 1);
      const distance = banner.getBoundingClientRect().width;
      if (!(duration > 0 && distance > 0)) return;
      // One 30 px perforation repeat travels at the announcement's actual px/s.
      const cycle = 30 * duration / distance;
      const animation = banner.getAnimations().find(item => item.animationName === style.animationName);
      const phase = ((Number(animation?.currentTime) || 0) / 1000) % cycle;
      document.querySelectorAll('.belly-social').forEach(section => {
        section.style.setProperty('--belly-film-cycle', `${cycle}s`);
        section.style.setProperty('--belly-film-delay', `${-phase}s`);
        section.style.setProperty('--belly-film-direction', style.animationName === 'translateRight' ? 'reverse' : 'normal');
        section.style.setProperty('--belly-film-state', style.animationPlayState);
      });
    };
    const initFilm = () => {
      const banner = document.querySelector('.shopify-section-group-header-group scrolling-banner .banner');
      if (banner && banner !== watchedBanner) {
        observer?.disconnect();
        watchedBanner = banner;
        observer = new ResizeObserver(syncFilm);
        observer.observe(banner);
        const header = banner.closest('scrolling-banner');
        header.addEventListener('mouseenter', syncFilm);
        header.addEventListener('mouseleave', syncFilm);
      }
      syncFilm();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFilm, { once: true });
    else initFilm();
    document.fonts?.ready.then(syncFilm);
    window.addEventListener('pageshow', syncFilm);
    document.addEventListener('shopify:section:load', initFilm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belly-tracking"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('belly-shipment-tracker')) {
  customElements.define('belly-shipment-tracker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      const input = this.querySelector('input');
      const status = this.querySelector('[role="status"]');
      const fallback = this.querySelector('.belly-tracking__fallback');
      const link = fallback?.querySelector('a');
      const nojs = this.querySelector('.belly-tracking__nojs');
      if (!form || !input || !status || !fallback || !link || !nojs) return;
      this.initialized = true;
      input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        status.textContent = '';
        fallback.hidden = true;
        link.removeAttribute('href');
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const number = input.value.trim().toUpperCase();
        if (!/^[A-Z0-9][A-Z0-9 -]{4,48}[A-Z0-9]$/.test(number)) {
          input.setAttribute('aria-invalid', 'true');
          fallback.hidden = true;
          link.removeAttribute('href');
          status.textContent = this.dataset.invalid;
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        const language = this.dataset.language === 'it' ? 'it' : 'en';
        link.href = 'https://t.17track.net/' + language + '#nums=' + encodeURIComponent(number);
        fallback.hidden = false;
        status.textContent = this.dataset.opened;
        link.click();
      });
      nojs.hidden = true;
      form.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
